import './Header.css';
import {React, useState, useEffect, useRef, useDispatch} from 'react';

import {useSelector} from 'react-redux';
import store  from './store';
import allReducers from './reducers';
import { connect } from "react-redux";

import {useNavigate} from 'react-router-dom';

import { toggleDarkMode, useWindowDimensions } from './actions/actions';
import cx from "classnames";

const Header = ({ activeDarkMode, toggleDarkMode}) => {
  const [hideMenu, setHideMenu] = useState(window.innerWidth < 481)


  const navigate = useNavigate();
  const isInitialRender = useRef(true);

  const handleToggle = () => {
    setHideMenu(!hideMenu);
  };


  useEffect(() => {
    if(!isInitialRender.current) {
      console.log("useeffect here")
      navigate('/', { state: { darkMode: activeDarkMode } });
    }else {
       isInitialRender.current = false;
    }
  }, [activeDarkMode])

  return (
    <header className="header">
      <div className="header_logo">
        <a href="/" className="logo" style={{"textDecoration":"none"}}>
        <span className="logo_text">Nitin Patil</span>
        </a>
      </div>
      <div className="header_menu">
          {activeDarkMode}
          <nav className={cx(
            "menu_list", {hidden: hideMenu}
          )}>
            <ul className="menu_items menu_items_desktop">
              <li><a href="/blogposts">Blog</a></li>
              <li><a href="https://calendly.com/nitinpatil1992">Contact</a>
              </li>
            </ul>
            <ul className="menu_items menu_items_mobile">
              <li><a href="/blogposts">Blog</a></li>
              <li><a href="https://calendly.com/nitinpatil1992">Contact</a></li>
            </ul>
          </nav>
          <span className="menu-trigger" onClick={handleToggle}>
            <svg viewBox="0 0 100 80" width="20" height="20">
              <rect width="100" height="20"></rect>
              <rect y="30" width="100" height="20"></rect>
              <rect y="60" width="100" height="20"></rect>
            </svg>
          </span>
          <span className="theme-toggle"  onClick={() => toggleDarkMode()}>
            <svg className="theme-toggler" width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" >
              <path d="M22 41C32.4934 41 41 32.4934 41 22 41 11.5066 32.4934 3 22 3 11.5066 3 3 11.5066 3 22s8.5066 19 19 19zM7 22C7 13.7157 13.7157 7 22 7V37C13.7157 37 7 30.2843 7 22z">
              </path>
            </svg>
          </span>
      </div>
    </header>
  )
}

const mapStateToProps = state => {
  return { activeDarkMode: state.counter.darkMode };
};

export default connect(
  mapStateToProps,
  {toggleDarkMode}
)(Header);
